import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/codebuild/output/src879763043/src/codemochi-courses/src/components/routes/public/Lecture.tsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <div className="objective">
  <p>
    <span>Objective:</span> Create a `my-recipes/[id]` route to allow users to
    edit their own pages.
  </p>
    </div>
    <p>{`Let's create the my-recipe page which will turn into the update recipe page after we create a component for that in the next step. For now though, we will keep it simple. Create the following file:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-pages/my-recipes/[id].tsx"
      }}>{`import { MainLayout } from '../../components/layout/MainLayout';

const MyRecipe = ({ id }) => {
  return (
    <MainLayout title="Update Recipe">
      <h1>Update Recipe</h1>
    </MainLayout>
  );
};

MyRecipe.getInitialProps = ({ query }) => {
  const { id } = query;
  return { id };
};

export default MyRecipe;

`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      